/**
 * 아이콘 레지스트리 API — 아이콘 관리(커스텀 SVG) + AI 생성.
 * admin BFF /api/admin/icons/* (workchat Postgres admin_icon_registry).
 */
import { apiClient } from './client';

export interface IconRow {
  id: number;
  name: string;
  label: string;
  svg: string;
  source: string;
  prompt: string | null;
  created_at: string;
  updated_at: string;
}
export interface IconInput { name: string; label?: string; svg: string; source?: string; prompt?: string | null; }

export async function listIcons(): Promise<IconRow[]> {
  const { data } = await apiClient.get<{ icons: IconRow[] }>('/admin/icons');
  return Array.isArray(data?.icons) ? data.icons : [];
}
export async function createIcon(input: IconInput): Promise<IconRow> {
  const { data } = await apiClient.post<IconRow>('/admin/icons', input);
  return data;
}
export async function updateIcon(id: number, patch: Partial<IconInput>): Promise<IconRow> {
  const { data } = await apiClient.patch<IconRow>(`/admin/icons/${id}`, patch);
  return data;
}
export async function deleteIcon(id: number): Promise<void> {
  await apiClient.delete(`/admin/icons/${id}`);
}
/** AI 로 SVG 생성(저장 안 함, 미리보기 svg 반환). */
export async function generateIconSvg(prompt: string): Promise<{ ok: boolean; svg: string; model?: string }> {
  // timeout 0 = 무제한: 서버측 동적 타임아웃(icon_generate_ms)이 실효 게이트.
  const { data } = await apiClient.post<{ ok: boolean; svg: string; model?: string }>('/admin/icons/generate', { prompt }, { timeout: 0 });
  return data;
}
